import gql from 'graphql-tag';

export const contactCreate = gql`
  mutation contactCreate($input: ContactCreateInput!) {
    contactCreate(input: $input) {
      contact {
        id
        first_name
        last_name
        emails(slice: { limit: 1 }) {
          records {
            id
            email_address
          }
        }
        phones(slice: { limit: 1 }) {
          records {
            id
            phone_number
          }
        }
      }
    }
  }
`;

export const contactUpdate = gql`
  mutation contactUpdate($input: ContactUpdateInput!) {
    contactUpdate(input: $input) {
      contact {
        id
        first_name
        last_name
        emails(slice: { limit: 1 }) {
          records {
            id
            email_address
          }
        }
        phones(slice: { limit: 1 }) {
          records {
            id
            phone_number
          }
        }
      }
    }
  }
`;

export const contactDelete = gql`
  mutation contactDelete($input: ContactDeleteInput!) {
    contactDelete(input: $input) {
      success
    }
  }
`;
